import { appSync, startListening } from '@bonanza-social/toolkit/state';
import { fetchPerksConfig } from './perksConfig.slice';

startListening({
  actionCreator: appSync,
  effect: (_, { dispatch }) => {
    dispatch(fetchPerksConfig());
  },
});
